import React from 'react';
import PropTypes from 'prop-types';
import EngineScoringClassificationAttributeListComponent from './EngineScoringClassificationAttributeListComponent';

const EngineScoringClassificationAttributeListContainer = ({
  engineScoringId,
  attributes,
  validation,
  engineClassificationIndex,
  isReadOnly,
  dispatch,
  engineAttributeOptions,
  useAllAttributes,
  evaluatedAttributes
}) => {
  return (
    <EngineScoringClassificationAttributeListComponent
      engineScoringId={engineScoringId}
      attributes={attributes}
      engineClassificationIndex={engineClassificationIndex}
      isReadOnly={isReadOnly}
      engineAttributeOptions={useAllAttributes ? engineAttributeOptions : evaluatedAttributes}
      dispatch={dispatch}
      validation={validation}
    />
  );
};

EngineScoringClassificationAttributeListContainer.propTypes = {
  engineScoringId: PropTypes.number.isRequired,
  attributes: PropTypes.array.isRequired,
  isReadOnly: PropTypes.bool.isRequired,
  dispatch: PropTypes.func.isRequired,
  engineClassificationIndex: PropTypes.number.isRequired,
  validation: PropTypes.object.isRequired,
  engineAttributeOptions: PropTypes.array.isRequired,
  useAllAttributes: PropTypes.bool.isRequired,
  evaluatedAttributes: PropTypes.array.isRequired
};

export default EngineScoringClassificationAttributeListContainer;
